import {BankAccount} from "./BankAccount";
import {MyLocation} from "./Location";


export class User {
    private _id:              number;
    private _email:           string;
    private _password:        string;
    private _name:            string;
    private _surname:         string;
    private _uuid:            string;
    private _phone:           string;
    private _access:          string;
    private _refresh:         string;
    private _role:            string;
    private _price:           number;
    private _bank_account:    BankAccount | null;
    private _id_number:       string;
    private _address:         string;
    private _drivers_license: string;
    private _id_document:     string;
    private _bank_statement:  string;
    private _vehicle_registration_number:string
    private _delivery_code: number;

    private _location:      MyLocation;
    private _last_login: Date;

    constructor() {
        this._id              = 0;
        this._email           = "";
        this._password        = "";
        this._name            = "";
        this._surname         = "";
        this._refresh         = "";
        this._uuid            = "";
        this._phone           = "";
        this._access          = "";
        this._role            = "";
        this._price           = 0;
        this._bank_account    = null;
        this._id_number       = "";
        this._address         = "";
        this._drivers_license = "";
        this._bank_statement  = "";
        this._id_document = "";
        this._vehicle_registration_number = ""
        this._delivery_code = 0
        this._location = new MyLocation();
        this._last_login = new Date()
    }

    get id(): number { return this._id; }
    set id(value: number) { this._id = value; }

    get email(): string { return this._email; }
    set email(value: string) { this._email = value; }

    get password(): string { return this._password; }
    set password(value: string) { this._password = value; }

    get name(): string { return this._name; }
    set name(value: string) { this._name = value; }

    get surname(): string { return this._surname; }
    set surname(value: string) { this._surname = value; }

    get refresh(): string { return this._refresh; }
    set refresh(value: string) { this._refresh = value; }

    get uuid(): string { return this._uuid; }
    set uuid(value: string) { this._uuid = value; }

    get phone(): string { return this._phone; }
    set phone(value: string) { this._phone = value; }

    get access(): string { return this._access; }
    set access(value: string) { this._access = value; }

    get role(): string { return this._role; }
    set role(value: string) { this._role = value; }

    get price(): number { return this._price; }
    set price(value: number) { this._price = value; }

    get bank_account(): BankAccount | null { return this._bank_account; }
    set bank_account(value: BankAccount | null) { this._bank_account = value; }

    get id_number(): string { return this._id_number; }
    set id_number(value: string) { this._id_number = value; }

    get address(): string { return this._address; }
    set address(value: string) { this._address = value; }

    get drivers_license(): string { return this._drivers_license; }
    set drivers_license(value: string) { this._drivers_license = value; }


    get bank_statement(): string { return this._bank_statement; }
    set bank_statement(value: string) { this._bank_statement = value; }


    get id_document(): string {
        return this._id_document;
    }

    set id_document(value: string) {
        this._id_document = value;
    }


    get vehicle_registration_number(): string {
        return this._vehicle_registration_number;
    }

    set vehicle_registration_number(value: string) {
        this._vehicle_registration_number = value;
    }


    get delivery_code(): number {
        return this._delivery_code;
    }

    set delivery_code(value: number) {
        this._delivery_code = value;
    }


    get location(): MyLocation {
        return this._location;
    }

    set location(value: MyLocation) {
        this._location = value;
    }


    get last_login(): Date {
        return this._last_login;
    }

    set last_login(value: Date) {
        this._last_login = value;
    }
}